const spend = ({primary, secondary}) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.1 159.4" width="190"
    >
        <g id="Home_page">
            <g>
                <g>
                    <path stroke={primary} fill="none"  strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10"  d="M149.7,58.1V28.1c0-14.5-11.9-26.2-26.7-26.2c-14.7,0-26.7,11.7-26.7,26.2v29.9 M96.2,58.1
				c3.2,0,5.7,2.5,5.7,5.6c0,3.1-2.5,5.6-5.7,5.6s-5.7-2.5-5.7-5.6C90.4,60.6,93,58.1,96.2,58.1z M149.4,58.1c3.2,0,5.7,2.5,5.7,5.6
				c0,3.1-2.5,5.6-5.7,5.6c-3.2,0-5.7-2.5-5.7-5.6C143.7,60.6,146.3,58.1,149.4,58.1z M65.6,153.7h115.2L171.2,41h-96L65.6,153.7z"
                    />
                    <path stroke={secondary} fill="none" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10"   d="M58.7,95.8V77.7c0-8.8-7.2-15.8-16.1-15.8c-8.9,0-16.1,7.1-16.1,15.8v18.1 M26.2,95.8
				c1.9,0,3.5,1.5,3.5,3.4c0,1.9-1.5,3.4-3.5,3.4c-1.9,0-3.5-1.5-3.5-3.4C22.8,97.3,24.3,95.8,26.2,95.8z M58.5,95.8
				c1.9,0,3.5,1.5,3.5,3.4c0,1.9-1.5,3.4-3.5,3.4c-1.9,0-3.5-1.5-3.5-3.4C55,97.3,56.6,95.8,58.5,95.8z M65.9,85.5H13.6l-5.8,68.2
				h52.5"/>
                </g>
                <polygon stroke={secondary} fill="none" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10"  points="122.9,79.3 114.6,95.5 97.3,98.8 109.5,112.1 107.1,130.3 122.9,122.4 138.7,130.3 136.3,112.1 
			148.4,98.8 131.2,95.5 		"/>
            </g>
        </g>
    </svg>
)

export default spend;